export default __webpack_public_path__ + "static/medium-image-bimp-1-e44e6aabcb3cdf0739b1379129a5a1e7.png";